import React from 'react';
import { AuthenticationWrapper } from '../AuthenticationWrapper';
import { FormContainer, ResetPasswordHeading, ResetPasswordSubheading } from '../style';
import UpdatePasswordFormContainer from '../../FormContainers/Authentication/UpdatePasswordForm';
import { UpdatePasswordForm } from '../../../Components/forms/AuthenticationForms/UpdatePassword';

export const UpdatePassword = () => (
    <AuthenticationWrapper>
        <FormContainer>
            <ResetPasswordHeading>New password</ResetPasswordHeading>
            <ResetPasswordSubheading>Hello, enter your new password below</ResetPasswordSubheading>
            <UpdatePasswordFormContainer renderForm={props => <UpdatePasswordForm {...props} />} />
        </FormContainer>
    </AuthenticationWrapper>
);



// WEBPACK FOOTER //
// ./src/UI/Containers/Authentication/ResetPassword/UpdatePassword.js